
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ResourcesPage from '../pages/resources/page';
import VerifyEmailPage from '../pages/auth/verify-email/page';
import AdminPasswordsPage from '../pages/admin/passwords/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/admin/passwords',
    element: <AdminPasswordsPage />,
  },
  {
    path: '/auth/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
